import { SHAPE_STROKE_PROPS } from './stroke-props';

interface RectangleProps {
  cornerRadius: number;
  strokeDasharray: string | undefined;
}

export default function Rectangle({ cornerRadius, strokeDasharray }: RectangleProps) {
  return (
    <rect
      x="0" y="0" width={100} height={100}
      rx={cornerRadius} ry={cornerRadius}
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
